import React, { createContext, useContext, useState, useCallback, useMemo, ReactNode } from 'react';

export type TCompany = {
  id:number,
  uid:string,
  name:string,
  image:string,
  public_key:string,
  alias?:string,
  subscription?: any
}
export type TModule = {
  id:number,
  company_id:number,
  name:string,
  description:string,
  app:string,
  path:string,
  icon:string,
  active:boolean
}

export type TModuleOption = {
  id:number,
  key:string,
  type:string,
  module_id:number,
  company_id:number,
  legal_code:string,
  string_value:string,
  numeric_value:number,
  show:boolean
}

type TCompanyContext = {
  current:TCompany,
  list: TCompany[],
  moduleList: TModule[],
  currentModule: TModule,
  moduleOptions: TModuleOption[]
}

const initialState:TCompanyContext = {
  current:{
    id:0,
    uid:"",
    name:"",
    image:"",
    public_key:"",
    alias:"",
    subscription: null
  },
  list: [],
  moduleList: [],
  currentModule: {
    id:0,
    company_id:0,
    name:"",
    description:"",
    app:"",
    path:"",
    icon:"",
    active:false
  },
  moduleOptions: []
}


interface CompanyContextType {
  company: TCompanyContext;
  updateCompany: (newConfig: Partial<TCompanyContext>) => void;
}
interface CompanyProviderProps {
  children: ReactNode;
}

const CompanyContext = createContext<CompanyContextType>({company:initialState,updateCompany:()=>{}});

export const CompanyProvider:React.FC<CompanyProviderProps> = ({ children }) => {
  const [company, setCompany] = useState(initialState);
  const updateCompany = useCallback((newCompany:Partial<TCompanyContext>) => {
    setCompany((prevCompany) => ({ ...prevCompany, ...newCompany }));
  }, []);

  const contextValue = useMemo(() => ({
    company,
    updateCompany,
  }), [company, updateCompany]);

  return (
    <CompanyContext.Provider value={contextValue}>
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompany = () => {
  return useContext(CompanyContext);
};
